import { createRouter, createWebHistory } from 'vue-router'
import BreathTrainer from '../components/BreathTrainer.vue'
import NeckTrainer from '../components/NeckTrainer.vue'

const routes = [
  {
    path: '/',
    redirect: '/breath'
  },
  {
    path: '/breath',
    name: 'BreathTrainer',
    component: BreathTrainer
  },
  {
    path: '/neck',
    name: 'NeckTrainer',
    component: NeckTrainer
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 